import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e80bd164"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DailyCust" }

import { searchFormConfig } from "./config/search.config";
import { contentTableConfig } from "./config/content.config";
import { modalConfig } from "./config/modal.config";
import { usePageSearch } from "@/hooks/userPageSearch";
import { usePageModal } from "@/hooks/usePageModal";
import { initEmptyParam } from "@/hooks/useInitParam";
import { reactive, ref } from "vue";
import { useUpload } from "@/hooks/useUpload";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyCust',
  setup(__props) {

initEmptyParam()
const modalTitle = ref('新增')
const otherInfo = reactive({
})

const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed] =
  useUpload()
const fileList = ref<any[]>([])

const newCb = () => {
  modalTitle.value = '每日填报'
}

const editCb = (item: any) => {
  modalTitle.value = '编辑'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const handleSortChange = (value: any)=> {
  let orderBy = value.prop;
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "dailyCust",
      downFilename: "投教顾问人员日常基础数据.xlsx",
      onFillBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onSortChange: handleSortChange,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onFillBtnClick", "onEditBtnClick", "onDownBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "dailyCust",
      otherInfo: otherInfo
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})